var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"patient-terms"},[_c('h1',{staticClass:"patient-terms__title"},[_vm._v("Termos de uso")]),(_vm.consentForm)?_c('iframe',{attrs:{"src":_vm.pdfUrl,"frameborder":"0"}}):_c('div',{staticClass:"patient-terms__content",domProps:{"innerHTML":_vm._s(_vm.currentTermsOfUse)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }